import { PageQuery, Paginate } from '@business/entities/common';
import { CommonService } from '@business/services';
import { R } from '@core/utils/r';
import { ProductFormData } from '@modules/orders/ProductsPage/AddEditProductOverlay/AddEditProductOverlay';
import { Endpoint } from '../endpoint';
import { OrderPackageId, OrderPackageResponse, VeryCompactPackageProductResponse } from '@business/entities/order/OrderPackageResponse';

export function fetchPackagesPaginated(params: PageQuery, products?: OrderPackageId[], vendorId?: string) {
  return Endpoint.get<Paginate<OrderPackageResponse>>(`@gc/packages`, { params: R.objectCompact({ ...params, products, vendorId }) });
}

export function fetchPackages(isPaginated = true) {
  return Endpoint.get<OrderPackageResponse[]>(`@gc/packages`, { params: { isPaginated } });
}

export function fetchPackage(id: OrderPackageId) {
  return Endpoint.get<OrderPackageResponse>(`@gc/packages/package/${id}`);
}

export function createPackage(data: Partial<ProductFormData>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<OrderPackageResponse>(`@gc/packages`, { formData, hasFiles: true });
}

export function updatePackage(id: OrderPackageId, data: Partial<ProductFormData>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<OrderPackageResponse>(`@gc/packages/package/${id}`, { formData, hasFiles: true });
}

export function deletePackage(id: OrderPackageId) {
  return Endpoint.delete<void>(`@gc/packages/${id}`);
}

export function syncPackages() {
  return Endpoint.get<OrderPackageResponse[]>(`@gc/packages/sync`);
}

export function deletePackageProduct(id: string) {
  return Endpoint.delete<OrderPackageResponse>(`@gc/packages/product/${id}`);
}

export function saveProducts(id: OrderPackageId, products: VeryCompactPackageProductResponse[]) {
  return Endpoint.post<OrderPackageResponse>(`@gc/packages/product/${id}`, { data: { products } });
}
